import {
  createGlobalStyle,
  css,
} from 'styled-components';

const GlobalStyles = createGlobalStyle`
  ${() => css`
    html {
      font-family: Roboto;
    }

    &::-webkit-scrollbar {
      height: 4px;
      width: 4px;
      background-color: #ccc;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: #ccc;
    }
  `}
`;

export default GlobalStyles;
